import { render, staticRenderFns } from "./totalSumChart.vue?vue&type=template&id=5b6a68bc&scoped=true&"
import script from "./totalSumChart.vue?vue&type=script&lang=js&"
export * from "./totalSumChart.vue?vue&type=script&lang=js&"
import style0 from "./totalSumChart.vue?vue&type=style&index=0&id=5b6a68bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a68bc",
  null
  
)

export default component.exports